import Services from './base-services'

const service = new Services('report')
import mapParameters from '../utils/map-parameters'

export default {
    getEvolutionByReader(userId: number|string) {
        const params = mapParameters({
            userId: userId ? userId : null
        })
        return service.get(`getEvolutionByReader`, params)
    }
}
